import { render } from "./PageBlockText.vue?vue&type=template&id=5dd895f2"
import script from "./PageBlockText.vue?vue&type=script&lang=js"
export * from "./PageBlockText.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/bezbedno/admin/static/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"js/Components/PageBlocks/PageBlockText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5dd895f2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5dd895f2', __exports__)) {
    console.log('reload')
    api.reload('5dd895f2', __exports__)
  }
  
  module.hot.accept("./PageBlockText.vue?vue&type=template&id=5dd895f2", () => {
    console.log('re-render')
    api.rerender('5dd895f2', render)
  })

}


export default __exports__